import { ActionReducer } from '@ngrx/store';

import { PatientRecordsState} from './patient-records.model';
import { initialState, SEARCH_PATIENT_RECORDS, GET_PATIENT_RECORDS, RESET_PATIENT_RECORDS_GRID_DATA, RESET_PATIENT_RECORDS_TO_INITIAL_STATE } from './patient-records.constants';
import { CLEAR_ALL_STORES_STATE, CustomAction } from '../index-store.constants';

export function patientRecordsReducer(state: PatientRecordsState = initialState, action: CustomAction) {
    switch (action.type) {
        case SEARCH_PATIENT_RECORDS:
            return {
                patientRecordsSearchFilterFields: action.payload,
                patientRecordsSearchGridData: state.patientRecordsSearchGridData
            };
        case GET_PATIENT_RECORDS:
            return {
                patientRecordsSearchFilterFields: state.patientRecordsSearchFilterFields,
                patientRecordsSearchGridData: {
                    rowsPerPageOptions: state.patientRecordsSearchGridData.rowsPerPageOptions,
                    cols: state.patientRecordsSearchGridData.cols,
                    pageLinks: state.patientRecordsSearchGridData.pageLinks,
                    rows: action.payload.rows,
                    configuration: action.payload.configuration,
                    filterData: action.payload.filterData,
                    totalRecords: action.payload.totalRecords
                }
            };
        case RESET_PATIENT_RECORDS_GRID_DATA:
            return {
                patientRecordsSearchFilterFields: state.patientRecordsSearchFilterFields,
                patientRecordsSearchGridData: initialState.patientRecordsSearchGridData
            };
        case RESET_PATIENT_RECORDS_TO_INITIAL_STATE:            
        case CLEAR_ALL_STORES_STATE:
            return {
                patientRecordsSearchFilterFields: initialState.patientRecordsSearchFilterFields,
                patientRecordsSearchGridData: initialState.patientRecordsSearchGridData
            };
        default:
            return state;
    }
}
